import { gql } from "@grandvisionhq/graphql";
const GET_PREFERRED_STORE_ID = gql`
  query getPreferredStoreId {
    me {
      id
      preferredStore {
        globalStoreId
      }
    }
  }
`;
export {
  GET_PREFERRED_STORE_ID as default
};
//# sourceMappingURL=get-preferred-store-id.js.map
